ixModuleRouting("impactx.classificationmaterialgroup", {
    "/classificationmaterialgroup": {
        template: "<ixa-classification-material-group-list></ixa-classification-material-group-list>",
        templateUrl:
            "modules/classificationmaterialgroup/templates/classificationmaterialgrouplist.html",
        process: "ClassificationMaterialGroup",
        controller: "ClassificationMaterialGroupListController",
        controllerAs: "classificationMaterialGroupListController",
        workspace: "admin",
    },
    "/classificationmaterialgroup/:id": {
        template: "<ixa-classification-material-group></ixa-classification-material-group>",
        templateUrl:
            "modules/classificationmaterialgroup/templates/classificationmaterialgroup.html",
        process: "ClassificationMaterialGroup",
        controller: "ClassificationMaterialGroupCtrl",
        controllerAs: "classificationMaterialGroupCtrl",
        workspace: "admin",
    },
});
